var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.33,
    height: 31.464,
    viewBox: "0 0 33.33 31.464",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.88,
    y1: 4.806,
    x2: 1.88,
    y2: 3.952,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d6b40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217748"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(66.394 22.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape306-18",
    transform: "translate(-52.895 -18.406)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect102",
    width: 18.96,
    height: 23.953,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape23-20",
    transform: "translate(-54.965 -19.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path107",
    d: "M1.346,389.147A1.34,1.34,0,0,0,0,390.488v22.628a1.341,1.341,0,0,0,1.346,1.341h19.21a1.341,1.341,0,0,0,1.346-1.341V390.488a1.34,1.34,0,0,0-1.346-1.341Zm-.27,1.111H20.814v23.075H1.076Z",
    transform: "translate(0 -389.147)",
    fill: "#1f7144"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group43-22",
    transform: "translate(-48.279 -15.794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape33-23",
    transform: "translate(6.442 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect114",
    width: 5.315,
    height: 2.87,
    fill: "#1f7144"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape34-25",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect119",
    width: 5.315,
    height: 2.87,
    fill: "#1f7144"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape35-27",
    transform: "translate(6.442 3.919)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect124",
    width: 5.315,
    height: 2.87,
    fill: "#1f7144"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape36-29",
    transform: "translate(0 3.906)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect129",
    width: 5.315,
    height: 2.87,
    fill: "#1f7144"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape37-31",
    transform: "translate(6.442 7.892)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect134",
    width: 5.315,
    height: 2.87,
    fill: "#1f7144"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape38-33",
    transform: "translate(0 7.892)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect139",
    width: 5.315,
    height: 2.87,
    fill: "#1f7144"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape39-35",
    transform: "translate(6.442 11.91)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect144",
    width: 5.315,
    height: 2.87,
    fill: "#1f7144"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape40-37",
    transform: "translate(0 11.884)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect149",
    width: 5.315,
    height: 2.87,
    fill: "#1f7144"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape41-39",
    transform: "translate(6.442 15.86)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect154",
    width: 5.315,
    height: 2.87,
    fill: "#1f7144"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape42-41",
    transform: "translate(0 15.86)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect159",
    width: 5.315,
    height: 2.87,
    fill: "#1f7144"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path439",
    d: "M-47.432,9.265V-22.2l-18.961,3.146V6.118Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "shape46-218",
    transform: "translate(-61.447 -12.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path555",
    d: "M2.473,458.971l1.313,3.412a2.07,2.07,0,0,1,.159.563,1.3,1.3,0,0,1,.122-.563l1.556-3.6,2.39-.142q-1.452,2.765-2.792,5.587l2.911,5.747-2.576-.153-1.566-3.75a1.249,1.249,0,0,1-.123-.46,1.235,1.235,0,0,1-.081.358L2.21,469.624,0,469.492l2.555-5.187-2.3-5.2Z",
    transform: "translate(0 -458.642)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.dba6b88f7c569071dc1a1d7efc45ebe7.svg";
export { ForwardRef as ReactComponent };